module.exports = __webpack_public_path__ + "static/media/e258b1fc-1930-4a68-90bf-fc1eb983a334.7c96eea0.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/e258b1fc-1930-4a68-90bf-fc1eb983a334.jpg
// module id = 858
// module chunks = 0